<div style="width: 100%;">
    <div class="controls">
        <button mat-stroked-button color="primary" (click)="getRegisterSteps()" [disabled]="submiting">
            <mat-icon>refresh</mat-icon>
            Carregar dados
        </button>
    </div>

    <ng-container *ngIf="submiting">
        <div class="empty-content" style="width: 100%">
            <mat-progress-spinner mode="indeterminate" diameter="30"></mat-progress-spinner>
        </div>
    </ng-container>
    <ng-container *ngIf="submiting == false">

        <ng-container *ngIf="barChartData.length == 0">
            <div class="empty-content" style="width: 100%">
                Se houver resultado do filtro aparecerá aqui
            </div>
        </ng-container>

        <ng-container *ngIf="barChartData.length > 0">
            <div #lineChartContainer style="height: 500px;">
                <div style="width: 100%">
                    <h2 style="margin-bottom: 0px">Distribuição por data</h2>
                    <p class="mat-body-1">Últimos 30 </p>
                    <ngx-charts-line-chart [view]="[lineChartWidth, lineChartWidth / 4]" [legend]="true"
                        [autoScale]="false" [timeline]="true" [showXAxisLabel]="true" [showYAxisLabel]="true"
                        [xAxis]="true" [yAxis]="true" xAxisLabel="Data" yAxisLabel="Quantidade" [timeline]="true"
                        [results]="lineChartData">
                    </ngx-charts-line-chart>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="barChartData.length > 0">
            <div #barChartContainer style="height: 500px;">
                <div style="width: 100%">
                    <h2>Total por passos</h2>
                    <ngx-charts-bar-horizontal [view]="[barChartWidth, barChartWidth / 5]" [results]="barChartData"
                        [gradient]="false" [xAxis]="true" [yAxis]="true" [legend]="true" [showXAxisLabel]="true"
                        [showYAxisLabel]="true" xAxisLabel="Quantidades" yAxisLabel="Passos">
                    </ngx-charts-bar-horizontal>
                </div>
            </div>
        </ng-container>

    </ng-container>

</div>